import { render } from "./border.md?vue&type=template&id=0b9ca7dc"
import script from "./border.md?vue&type=script&lang=js"
export * from "./border.md?vue&type=script&lang=js"
script.render = render

export default script